const hasShadowDom = (el) => {
    return !!el.shadowRoot && !!el.attachShadow;
};
const debounceEvent = (event, wait) => {
    const original = event._original || event;
    return {
        _original: event,
        emit: debounce(original.emit.bind(original), wait),
    };
};
const debounce = (func, wait = 0) => {
    let timer;
    return (...args) => {
        clearTimeout(timer);
        timer = setTimeout(func, wait, ...args);
    };
};

export { debounceEvent as d, hasShadowDom as h };

//# sourceMappingURL=utils.js.map